export default __webpack_public_path__ + "static/media/profile-default.a853341c.png";